import { render } from "./ReviewRatingComment.vue?vue&type=template&id=707a8df4"
import script from "./ReviewRatingComment.vue?vue&type=script&lang=js"
export * from "./ReviewRatingComment.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__